import React from "react";
import { Box } from "@mui/material";
import FilterAltOutlined from "@mui/icons-material/FilterAltOutlined";
import "./AppFilterBar.css";

export default function AppFilterBar({
  children,
  actions,
  icon = true,
  className = "",
  sx,
}) {
  return (
    <Box className={`app-filter-bar ${className}`.trim()} sx={sx}>
      {icon && <FilterAltOutlined className="app-filter-bar__icon" color="action" />}
      <Box className="app-filter-bar__fields">{children}</Box>
      {actions && <Box className="app-filter-bar__actions">{actions}</Box>}
    </Box>
  );
}
